export { SectionContainer } from './component';
export {
  SECTION_CONTAINER_VARIANT_CONTENT_OVERFLOWED,
  SECTION_CONTAINER_VARIANT_NORMAL,
  SECTION_CONTENT_WIDTH_FULL,
  SECTION_CONTENT_WIDTH_NORMAL,
} from './constants';
export type { Component, Props } from './types';
